import { createTypes, createAction } from 'lib/action'

// *get order history
const GET_ORDER_HISTORY = createTypes('orderhistory', 'get')

const getOrderHistory = {
  request: (data, loading) =>
    createAction(GET_ORDER_HISTORY.REQUEST, { data, loading }),
  success: (lists) => createAction(GET_ORDER_HISTORY.SUCCESS, { lists }),
  failure: () => createAction(GET_ORDER_HISTORY.FAILURE),
}

export { GET_ORDER_HISTORY, getOrderHistory }
